module.exports = __webpack_public_path__ + "img/stvrt-nadvorie.8803654a.jpg";